import { FC } from 'react';
import { Box, Button, SxProps } from '@mui/material';
import { useStyles } from '@sweatpals/react-ui-kit';
import { seeMoreButtonStyles } from './see-more-button.styles';

export interface SeeMoreButtonProps {
	sx?: {
		box?: SxProps;
		button?: SxProps;
	};
	onClick?(): void;
}

const SeeMoreButton: FC<SeeMoreButtonProps> = ({ sx, onClick }) => {
	const styles = useStyles(seeMoreButtonStyles);

	return (
		<Box
			sx={{
				...styles.flexRow,
				...styles.contentCenter,
				...styles.itemsCenter,
				...(sx?.box as object),
			}}
		>
			<Button onClick={onClick} sx={{ ...styles.button, ...(sx.button as object) }}>see more</Button>
		</Box>
	);
};

export default SeeMoreButton;
